// extracted by mini-css-extract-plugin
module.exports = {"Badge":"Badge__Badge__[hash_base64-5]"};